var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "../classes/BaseService";
import { NavigationAdapterContext } from "./NavigationAdapterContext";
export class NavigationService extends BaseService {
    constructor(framework) {
        super({
            initialState: {},
        });
        this.dynamicNavigationGroups = new Set();
        this.dynamicNavigationItems = new Set();
        this.framework = framework;
        this.context = new NavigationAdapterContext(this, framework);
    }
    init(adapter) {
        return __awaiter(this, void 0, void 0, function* () {
            this.adapter = adapter;
            this.initAdapter(adapter, this.context);
        });
    }
    getGroups(place) {
        return Array.from(this.dynamicNavigationGroups.values());
    }
    getItems(place) {
        return Array.from(this.dynamicNavigationItems.values());
    }
    registerDynamicNavigationGroup(group) {
        this.dynamicNavigationGroups.add(group);
        super.notifySubscribers();
        return () => {
            this.dynamicNavigationGroups.delete(group);
            super.notifySubscribers();
        };
    }
    registerDynamicNavigationItem(item) {
        this.dynamicNavigationItems.add(item);
        super.notifySubscribers();
        return () => {
            this.dynamicNavigationItems.delete(item);
            super.notifySubscribers();
        };
    }
}
//# sourceMappingURL=NavigationService.js.map